<template>
  <b-row>
    <b-col md="12">
      <b-input-group class="mt-3" :prepend="paginacionString" append="registros por pagina">
        <b-input-group-append>
          <b-form-select
            :options="listaSolicitudes.pageOptions"
            v-model="listaSolicitudes.perPage"
            @change="solicitudProviderLocal(1)">
            </b-form-select>
        </b-input-group-append>
      </b-input-group>
    </b-col>
    <b-pagination
      :total-rows="listaSolicitudes.totalRows"
      :per-page="listaSolicitudes.perPage"
      v-model="listaSolicitudes.currentPage"
      @input="(solicitudProviderLocal(listaSolicitudes.currentPage))"
      class="my-4 mx-auto"></b-pagination>
  </b-row>
</template>

<script>
import { mapActions } from "vuex";
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'SolicitudAltaModule/getSolicitudAltaField'
});


export default {
  name: "PaginacionSolicitudAltaMedica",
  watch: {
  },
  components: {
  },
  computed: {
    ...mapFields({
      listaSolicitudes: 'tabla',
    }),
    paginacionActual: function(){
      return this.listaSolicitudes.perPage * this.listaSolicitudes.currentPage;
    },
    paginacionDesde: function() {
      return (this.paginacionActual - this.listaSolicitudes.perPage);
    },
    paginacionHasta: function(){
      var paginahasta = this.paginacionDesde + this.listaSolicitudes.perPage;
      if((this.listaSolicitudes.totalRows - paginahasta) < 0 ){
        return this.listaSolicitudes.totalRows;
      }
      return paginahasta;
    },
    paginacionString: function(){
      return `Mostrando ${this.paginacionDesde} a ${this.paginacionHasta} de ${this.listaSolicitudes.totalRows} items.`;
    }
  },
  data() {
    return {
      disabled: false
    };
  },
  methods: {
    ...mapActions("SolicitudAltaModule",["solicitudProvider"]),
    verDetalles(item) {
      this.getSolicitud(item.Id);
    },
    solicitudProviderLocal: function(resetPagination) {
      this.disabled = true;
      console.log('resetPagination', resetPagination);
      this.solicitudProvider(resetPagination).then(r => {
        console.log('solicitudprovider then', r);

        this.disabled = false;
      });
    },
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/common/PaginacionSolicitudAltaMedica.vue